import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemStatement } from './components/ProblemStatement';
import { Features } from './components/Features';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemStatement data-id="element-4" />
        <Features data-id="element-5" />
        <SocialProof data-id="element-6" />
        <Pricing data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}